import React from "react";
import { Button, Card } from "components/ui/BootstrapCompat";
import { formatCurrency } from "../withdraw.utils";

type Props = {
  isLoadingWallet: boolean;
  isLoadingKyc: boolean;
  canWithdraw: boolean;
  availableAmount: number;
  feeAmount: number;
  netAmount: number;
  currencyLabel: string;
  kycStatusLabel: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  onWithdrawClick: () => void;
};

export default function WithdrawSummaryCard(props: Props) {
  const {
    isLoadingWallet,
    isLoadingKyc,
    canWithdraw,
    availableAmount,
    feeAmount,
    netAmount,
    currencyLabel,
    kycStatusLabel,
    bankName,
    accountName,
    accountNumber,
    onWithdrawClick,
  } = props;

  return (
    <Card>
      <Card.Body>
        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 className="mb-1 text-lg font-semibold text-primary">
              ຈຳນວນເງິນທີ່ຖອນໄດ້
            </h2>
            <p className="mb-0 text-sm text-gray-500">
              ຖອນທັງຍອດ (ຄ່າທຳນຽມ {formatCurrency(feeAmount)}{" "}
              {currencyLabel})
            </p>
          </div>
          <Button
            variant="primary"
            disabled={!canWithdraw || isLoadingWallet || isLoadingKyc}
            onClick={onWithdrawClick}
          >
            ຖອນເງິນ
          </Button>
        </div>

        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <div className="rounded border border-gray-200 bg-gray-50 p-3">
            <div className="text-sm text-gray-500">ຍອດຄົງເຫຼືອ</div>
            <div className="text-3xl font-bold text-primary">
              {isLoadingWallet ? "..." : formatCurrency(availableAmount)}{" "}
              {currencyLabel}
            </div>
          </div>
          <div className="rounded border border-gray-200 bg-gray-50 p-3">
            <div className="text-sm text-gray-500">ຍອດຮັບສຸດທິ</div>
            <div className="text-3xl font-bold text-emerald-600">
              {isLoadingWallet ? "..." : formatCurrency(netAmount)}{" "}
              {currencyLabel}
            </div>
          </div>
        </div>

        <div className="mt-3 rounded border border-gray-200 bg-white p-3">
          <div className="grid gap-2 sm:grid-cols-2">
            <div>
              <div className="text-sm text-gray-500">ສະຖານະ KYC</div>
              <div className="mt-1 font-semibold text-gray-800">
                {isLoadingKyc ? "..." : kycStatusLabel}
              </div>
            </div>
            <div>
              <div className="text-sm text-gray-500">ບັນຊີທະນາຄານ (KYC)</div>
              <div className="mt-1 text-sm text-gray-800">
                <div className="font-semibold">
                  {accountName || "-"} ({bankName || "-"})
                </div>
                <div className="text-gray-600">{accountNumber || "-"}</div>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
